import type { CameraStatus, RecordingState } from './api/types';

const dtf = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'medium' });
const tf = new Intl.DateTimeFormat('pt-BR', { timeStyle: 'medium' });

export const fmtDateTime = (v: string | Date | null | undefined) => (v ? dtf.format(new Date(v)) : '—');
export const fmtTime = (v: string | Date) => tf.format(new Date(v));

export function fmtRelative(v: string | null | undefined): string {
  if (!v) return 'nunca';
  const s = Math.round((Date.now() - new Date(v).getTime()) / 1000);
  if (s < 10) return 'agora';
  if (s < 60) return `há ${s} s`;
  if (s < 3600) return `há ${Math.round(s / 60)} min`;
  if (s < 86400) return `há ${Math.round(s / 3600)} h`;
  return `há ${Math.round(s / 86400)} d`;
}

export function fmtBytes(n: number): string {
  if (n < 1e3) return `${n} B`;
  if (n < 1e6) return `${(n / 1e3).toFixed(1)} kB`;
  if (n < 1e9) return `${(n / 1e6).toFixed(1)} MB`;
  return `${(n / 1e9).toFixed(2)} GB`;
}

export const ROLE_LABEL: Record<string, string> = {
  company_admin: 'Administrador',
  operator: 'Operador',
  viewer: 'Visualizador',
  platform_admin: 'Admin. da plataforma',
};

export const CAMERA_STATUS: Record<CameraStatus, { label: string; cls: string }> = {
  online: { label: 'Online', cls: 'ok' },
  offline: { label: 'Offline', cls: 'crit' },
  auth_failed: { label: 'Falha de autenticação', cls: 'crit' },
  error: { label: 'Erro', cls: 'warn' },
  unknown: { label: 'Verificando', cls: '' },
  disabled: { label: 'Desativada', cls: '' },
};

export const RECORDING_STATE: Record<RecordingState, { label: string; cls: string }> = {
  idle: { label: 'Sem gravação', cls: '' },
  starting: { label: 'Iniciando', cls: 'info' },
  recording: { label: 'Gravando', cls: 'ok' },
  failing: { label: 'Falha na gravação', cls: 'crit' },
  blocked: { label: 'Bloqueada', cls: 'crit' },
};

export const RECORDING_MODE: Record<string, string> = {
  off: 'Desligada',
  continuous: 'Contínua',
  schedule: 'Por agenda',
  motion: 'Por movimento',
};

export const SEVERITY: Record<string, { label: string; cls: string }> = {
  info: { label: 'Info', cls: 'info' },
  warning: { label: 'Atenção', cls: 'warn' },
  critical: { label: 'Crítico', cls: 'crit' },
};

export const EVENT_TYPES: Record<string, string> = {
  'camera.online': 'Câmera reconectada',
  'camera.offline': 'Câmera offline',
  'camera.auth_failed': 'Falha de autenticação',
  'camera.error': 'Erro de câmera',
  'camera.created': 'Câmera cadastrada',
  'camera.deleted': 'Câmera removida',
  'gateway.connected': 'Gateway conectado',
  'gateway.disconnected': 'Gateway desconectado',
  'gateway.enrolled': 'Gateway inscrito',
  'gateway.revoked': 'Gateway revogado',
  'recording.started': 'Gravação iniciada',
  'recording.stopped': 'Gravação encerrada',
  'recording.failed': 'Falha na gravação',
  'recording.blocked': 'Gravação bloqueada',
  'recording.gap': 'Lacuna de gravação',
  'recording.corrupt': 'Segmento corrompido',
  'recording.missing': 'Arquivo ausente',
  'storage.retention': 'Retenção aplicada',
  'storage.quota_exceeded': 'Cota esgotada',
  'storage.critical': 'Armazenamento crítico',
  'stream.failed': 'Stream falhando',
  'motion.detected': 'Movimento detectado',
  'motion.ended': 'Fim de movimento',
  'motion.error': 'Falha na detecção',
};

/** Data local (YYYY-MM-DD) para inputs de data. */
export function localDateInput(d = new Date()) {
  const off = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - off).toISOString().slice(0, 10);
}
